/* eslint-disable no-return-await */
import { useQuery } from "@tanstack/react-query";
import { instanceConexao } from "services/axiosServices";
import { obterIdTokenAadConexao } from "services/conexaoAuth";

/**
 * Busca os dados cadastrais do autônomo.
 *
 * Usa `v2/obter-por-email`, autenticada pelo ID token do **Azure AD**: lá o e-mail consultado
 * tem de coincidir com o do token, então ninguém obtém os dados de outra pessoa.
 */
const buscarAutonomo = async (email: string): Promise<any> => {
  const idTokenAad = await obterIdTokenAadConexao();

  if (!idTokenAad) {
    throw new Error(
      "Não foi possível obter o token do Azure AD para consultar os dados do autônomo."
    );
  }

  return await instanceConexao.get(
    `/api/autonomo/v2/obter-por-email/${email}`,
    { headers: { Authorization: `Bearer ${idTokenAad}` } }
  );
};

export const fetchAutonomo = (email: string): any => {
  const fetch = async (): Promise<any> => {
    const response = await buscarAutonomo(email);

    if (response?.data?.success) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.notifications[0]?.message);
  };

  const query = useQuery({
    queryFn: async () => await fetch(),
    queryKey: ["fetch-autonomo", email],
    enabled: !!email,
    refetchOnWindowFocus: false,
  });

  return query;
};

export const getAutonomoSimplified = async (email: string): Promise<any> => {
  const response = await buscarAutonomo(email);
  return response?.data?.data;
};
